import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

const BrandsPage = lazyWithRetry(() => import("@/pages/BrandsPage"));
const BrandDetailPage = lazyWithRetry(() => import("@/pages/BrandDetailPage"));
const ThermoticLandingPage = lazyWithRetry(() => import("@/pages/brands/ThermoticLandingPage"));
const BozitaLandingPage = lazyWithRetry(() => import("@/pages/brands/BozitaLandingPage"));
const AcanaLandingPage = lazyWithRetry(() => import("@/pages/brands/AcanaLandingPage"));
const DogmanLandingPage = lazyWithRetry(() => import("@/pages/brands/DogmanLandingPage"));
const RoyalCaninLandingPage = lazyWithRetry(() => import("@/pages/brands/RoyalCaninLandingPage"));
const OrijenLandingPage = lazyWithRetry(() => import("@/pages/brands/OrijenLandingPage"));
const EukanubaLandingPage = lazyWithRetry(() => import("@/pages/brands/EukanubaLandingPage"));
const HillsLandingPage = lazyWithRetry(() => import("@/pages/brands/HillsLandingPage"));
const KongLandingPage = lazyWithRetry(() => import("@/pages/brands/KongLandingPage"));
const TrixieLandingPage = lazyWithRetry(() => import("@/pages/brands/TrixieLandingPage"));
const SavicLandingPage = lazyWithRetry(() => import("@/pages/brands/SavicLandingPage"));
const FlexiLandingPage = lazyWithRetry(() => import("@/pages/brands/FlexiLandingPage"));
const VerseleLagaLandingPage = lazyWithRetry(() => import("@/pages/brands/VerseleLagaLandingPage"));
const ApplawsLandingPage = lazyWithRetry(() => import("@/pages/brands/ApplawsLandingPage"));
const HurttaLandingPage = lazyWithRetry(() => import("@/pages/brands/HurttaLandingPage"));
const BioganceLandingPage = lazyWithRetry(() => import("@/pages/brands/BioganceLandingPage"));
const FuzzYardLandingPage = lazyWithRetry(() => import("@/pages/brands/FuzzYardLandingPage"));
const HappyDogLandingPage = lazyWithRetry(() => import("@/pages/brands/HappyDogLandingPage"));
const JacsonLandingPage = lazyWithRetry(() => import("@/pages/brands/JacsonLandingPage"));
const FourFriendsLandingPage = lazyWithRetry(() => import("@/pages/brands/FourFriendsLandingPage"));

export const brandRoutes = (
  <>
    <Route path="/varumarken" element={<ErrorBoundary><BrandsPage /></ErrorBoundary>} />
    <Route path="/alla-varumarken" element={<ErrorBoundary><BrandsPage /></ErrorBoundary>} />
    <Route path="/alla-varumärken" element={<ErrorBoundary><BrandsPage /></ErrorBoundary>} />
    <Route path="/varumärken" element={<Navigate to="/varumarken" replace />} />
    <Route path="/varumarke/thermotic" element={<ThermoticLandingPage />} />
    <Route path="/varumarke/bozita" element={<BozitaLandingPage />} />
    <Route path="/varumarke/acana" element={<AcanaLandingPage />} />
    <Route path="/varumarke/dogman" element={<DogmanLandingPage />} />
    <Route path="/varumarke/royal-canin" element={<RoyalCaninLandingPage />} />
    <Route path="/varumarke/orijen" element={<OrijenLandingPage />} />
    <Route path="/varumarke/eukanuba" element={<EukanubaLandingPage />} />
    <Route path="/varumarke/hills" element={<HillsLandingPage />} />
    <Route path="/varumarke/kong" element={<KongLandingPage />} />
    <Route path="/varumarke/trixie" element={<TrixieLandingPage />} />
    <Route path="/varumarke/savic" element={<SavicLandingPage />} />
    <Route path="/varumarke/flexi" element={<FlexiLandingPage />} />
    <Route path="/varumarke/versele-laga" element={<VerseleLagaLandingPage />} />
    <Route path="/varumarke/applaws" element={<ApplawsLandingPage />} />
    <Route path="/varumarke/hurtta" element={<HurttaLandingPage />} />
    <Route path="/varumarke/biogance" element={<BioganceLandingPage />} />
    <Route path="/varumarke/fuzzyard" element={<FuzzYardLandingPage />} />
    <Route path="/varumarke/happy-dog" element={<HappyDogLandingPage />} />
    <Route path="/varumarke/jacson" element={<JacsonLandingPage />} />
    <Route path="/varumarke/fourfriends" element={<FourFriendsLandingPage />} />
    <Route path="/varumarke/:brandSlug" element={<BrandDetailPage />} />
  </>
);
